import React, {  useEffect, useState, useCallback, useRef } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next" 
import { useNavigate } from 'react-router-dom'; 
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { ENDPOINT,CANVAS_SIZE } from "constants/variables";
import { es } from 'date-fns/locale';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box'; 
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress'; 
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'; 
import Grid  from '@mui/material/Grid'; 
import SignatureCanvas from 'react-signature-canvas';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography'; 
import "css/generalSettings.css"; 
import "css/customDialog.css";
import { successErrorAction,warningErrorAction } from "actions/ErrorActions"; 
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import { NumericFormat } from 'components/utils/NumericFormat';
import ContractCreateOrEditOptTras  from "pages/contracts/editOrNewContract/ContractOptTrasEdit";
import ContractCreateOrEditOriTras  from "pages/contracts/editOrNewContract/ContractOriTrasEdit";
import ContractCreateOrEditAutTras  from "pages/contracts/editOrNewContract/ContractAutTrasEdit";
import ContractCreateOrEditDestTras from "pages/contracts/editOrNewContract/ContractDestTrasEdit";
import ContractCreateOrEditAutDest from "pages/contracts/editOrNewContract/ContractAutDestEdit";
import TableSortingCodeLERS from "pages/contracts/editOrNewContract/SortingTablesCodeLers";
import ContractCreateCodeLER from "pages/contracts/editOrNewContract/ContractNewCodeLER";   
import PropTypes from 'prop-types';  










const initialStateContract = {
  "id" : "",
  "owncontract_id" : "",
  "defaultStore_id":0, 
  "useraccount_id":0,
  "defaultformatnumber":1,
  "isFinished":true,
  "isScanned":false,
 
  "number_nt":"",
  "date_contract":"",
  "amount_contract":0,
  "periodicity_contract":"",
  "duration_contract":"",
  "other_information_contract":"",
  "conditions_contract":"",
  "obligations_contract":"",

  "contractopttrasstore_id": 0,
  "opt_tras_store_id" : 0,
  "opt_tras_documnettype_id" : 0,
  "opt_tras_documentid" : "",
  "opt_tras_tradename" : "",
  "opt_tras_name" : "",
  "opt_tras_contactname" : "",
  "opt_tras_nima":"", 
  "opt_tras_inscription":"",
  "opt_tras_grnp":"",
  "opt_tras_opt":0,
  "opt_tras_phone":"",
  "opt_tras_email":"",
  "opt_tras_roadtype_id" :  74,
  "opt_tras_street" : "",
  "opt_tras_country_id":  1,
  "opt_tras_country_name": "",
  "opt_tras_province_id": 30,
  "opt_tras_province_name": "",
  "opt_tras_postalcode_id": 6911,
  "opt_tras_postalcode_code":"",
  "opt_tras_postalcode_name": "",
  "opt_tras_community_id":  6, 
  "opt_tras_community_name": "",
  "opt_tras_roadtype_id_fiscal" : 74,
  "opt_tras_street_fiscal" : "",
  "opt_tras_country_id_fiscal":1,
  "opt_tras_country_name_fiscal" : "",
  "opt_tras_province_id_fiscal":30,
  "opt_tras_province_name_fiscal" : "",
  "opt_tras_postalcode_id_fiscal":6911,
  "opt_tras_postalcode_code_fiscal" : "",
  "opt_tras_postalcode_name_fiscal" : "",
  "opt_tras_community_id_fiscal":6,
  "opt_tras_community_name_fiscal" : "", 
      
  "contractoritrasstore_id": 0,
  "ori_tras_store_id" : 0,
  "ori_tras_documnettype_id" : 0,
  "ori_tras_documentid" : "",
  "ori_tras_tradename" : "",
  "ori_tras_name" : "",
  "ori_tras_contactname" : "",
  "ori_tras_contactname_employee_id" : 0,
  "ori_tras_contactname_documnettype_id" : 0,
  "ori_tras_contactname_documentid" : "",
  "ori_tras_contactname_firstaname" : "",
  "ori_tras_contactname_lastname1" : "",
  "ori_tras_contactname_lastname2" : "",
  "ori_tras_contactname_position" : "",
  "ori_tras_contactname_email" : "",
  "ori_tras_contactname_phone" : "",
  "ori_tras_nima":"",
  "ori_tras_inscription":"",
  "ori_tras_grnp":"",
  "ori_tras_opt":0,
  "ori_tras_phone":"",
  "ori_tras_email":"",
  "ori_tras_roadtype_id" :  74,
  "ori_tras_street" : "",
  "ori_tras_country_id": 1,
  "ori_tras_country_name": "",
  "ori_tras_province_id": 30,
  "ori_tras_province_name": "",
  "ori_tras_postalcode_id": 6911,
  "ori_tras_postalcode_code": "",
  "ori_tras_postalcode_name": "",
  "ori_tras_community_id": 6,
  "ori_tras_community_name": "",
  "ori_tras_roadtype_id_fiscal" :  74,
  "ori_tras_street_fiscal" : "",
  "ori_tras_country_id_fiscal": 1,
  "ori_tras_country_name_fiscal": "",
  "ori_tras_province_id_fiscal": 30,
  "ori_tras_province_name_fiscal": "",
  "ori_tras_postalcode_id_fiscal": 6911,
  "ori_tras_postalcode_code_fiscal": "",
  "ori_tras_postalcode_name_fiscal": "",
  "ori_tras_community_id_fiscal": 6,
  "ori_tras_community_name_fiscal": "",

  "aut_tras_store_id" : 0,
  "aut_tras_documnettype_id" : 0,
  "aut_tras_documentid" : "",
  "aut_tras_tradename" : "",
  "aut_tras_name" : "",
  "aut_tras_contactname" : "",
  "aut_tras_nima":"", 
  "aut_tras_inscription":"",
  "aut_tras_grnp":"",
  "aut_tras_opt":0,
  "aut_tras_phone":"",
  "aut_tras_email":"",
  "aut_tras_roadtype_id" : 74,
  "aut_tras_street" : "",
  "aut_tras_country_id": 1,
  "aut_tras_country_name": "",
  "aut_tras_province_id": 30,
  "aut_tras_province_name": "",
  "aut_tras_postalcode_id": 6911,
  "aut_tras_postalcode_code": "",
  "aut_tras_postalcode_name": "",
  "aut_tras_community_id": 6,
  "aut_tras_community_name":"",

  "contractdesttrasstore_id": 0,
  "dest_tras_store_id" : 0,
  "dest_tras_documnettype_id" : 0,
  "dest_tras_documentid" : "",
  "dest_tras_tradename" : "",
  "dest_tras_name" : "",
  "dest_tras_contactname" : "", 
  "dest_tras_contactname_position" : "",
  "dest_tras_nima":"",
  "dest_tras_inscription":"",
  "dest_tras_grnp":"",
  "dest_tras_opt":0,
  "dest_tras_phone":"",
  "dest_tras_email":"",
  "dest_tras_roadtype_id" : 74,
  "dest_tras_street" : "",
  "dest_tras_country_id": 1,
  "dest_tras_country_name": "",
  "dest_tras_province_id": 30,
  "dest_tras_province_name": "",
  "dest_tras_postalcode_id":6911,
  "dest_tras_postalcode_code": "",
  "dest_tras_postalcode_name": "",
  "dest_tras_community_id": 6,
  "dest_tras_community_name":"",
  "dest_tras_roadtype_id_fiscal": 74,
  "dest_tras_street_fiscal": "",
  "dest_tras_country_id_fiscal": 1,
  "dest_tras_country_name_fiscal": "",
  "dest_tras_province_id_fiscal": 30,
  "dest_tras_province_name_fiscal": "",
  "dest_tras_postalcode_id_fiscal": 6911,
  "dest_tras_postalcode_code_fiscal": "",
  "dest_tras_postalcode_name_fiscal": "",
  "dest_tras_community_id_fiscal": 6,
  "dest_tras_community_name_fiscal": "",

  "aut_dest_store_id" : 0,
  "aut_dest_documnettype_id" : 0,
  "aut_dest_documentid" : "",
  "aut_dest_tradename" : "",
  "aut_dest_name" : "",
  "aut_dest_contactname" : "",
  "aut_dest_nima":"", 
  "aut_dest_inscription":"",
  "aut_dest_grnp":"",
  "aut_dest_opt":0,
  "aut_dest_phone":"",
  "aut_dest_email":"",
  "aut_dest_roadtype_id" : 74,
  "aut_dest_street" : "",
  "aut_dest_country_id": 1,
  "aut_dest_country_name":"",
  "aut_dest_province_id": 30,
  "aut_dest_province_name":"",
  "aut_dest_postalcode_id": 6911,
  "aut_dest_postalcode_code":"",
  "aut_dest_postalcode_name":"",
  "aut_dest_community_id": 6,
  "aut_dest_community_name":"",

  "opttrasbilling":false,
  "oritrasbilling":false,
  "desttrasbilling":true,
  "reltransbilling":false,

  "opt_tras_shared":false,
  "ori_tras_shared":false,
  "aut_tras_shared":false,
  "dest_tras_shared":false,
  "aut_dest_shared":false,

  "sendbyemail_opt_tras":false,
  "sendbyemail_ori_tras":false,
  "sendbyemail_aut_tras":false,
  "sendbyemail_dest_tras":false,
  "sendbyemail_aut_dest":false,
 
  "signature_opt_tras":"",
  "signature_ori_tras":"",
  "signature_dest_tras":"",

  "codelers":[]

};
 
const initialDocumentTypesToSelect = [{
  "id": "",
  "name": "",
   "entitycode":"F"
}];
  
const initialCodeLERToSelect = [{
  "id": "",
  "indexrowcodeler":"",
  "codeler_id":"",
  "codeler_code": "",
  "codeler_namees": "",
  "codeler_nameen": "",
  "processtypes":[],
  "treatmenttypes":[]
}];


const initialRDToSelect = [{
  "id": "",
  "code": "",
  "namees": "",
  "nameen": ""
}];
   
const ContractEditOrCreate = ({id, showModalContractSettings}) => {
  const {t,i18n} = useTranslation(['listDataContracts']);
  const token = useSelector((state) => state.loginUser.token);  
  const roles = useSelector((state) => state.loginUser.roles);  
  const defaultStore = useSelector((state) => state.loginUser.defaultStore)
  const useraccount_id = useSelector((state) => state.loginUser.useraccount_id);  
  const defaulttypesdi = useSelector((state) => state.loginUser.defaulttypesdi);  
  const defaultsignature= useSelector((state) => state.loginUser.signature_default);  
  const DEFAULTTYPEOFDOCUMENT = useSelector((state) => state.formatDIUser.default_documenttype); 
  const DEFAULTROADTYE = useSelector((state) => state.formatDIUser.default_roadtype); 
  const DEFAULTCOUNTRY = useSelector((state) => state.formatDIUser.default_country); 
  const DEFAULTCOUNTRY_NAME = useSelector((state) => state.formatDIUser.default_country_name); 
  const DEFAULTPROVINCE = useSelector((state) => state.formatDIUser.default_province); 
  const DEFAULTPROVINCE_NAME = useSelector((state) => state.formatDIUser.default_province_name); 
  const DEFAULTPOSTALCODE_ID = useSelector((state) => state.formatDIUser.default_postalcode); 
  const DEFAULTPOSTALCODE_CODE = useSelector((state) => state.formatDIUser.default_postalcode_code); 
  const DEFAULTPOSTALCODE_NAME = useSelector((state) => state.formatDIUser.default_postalcode_name); 
  const DEFAULTCOMMUNITY = useSelector((state) => state.formatDIUser.default_community); 
  const DEFAULTCOMMUNITY_NAME = useSelector((state) => state.formatDIUser.default_community_name); 
  const DELETE_CODE = useSelector((state) => state.formatDIUser.delete_code); 
  const default_contract_view_aut_tras = useSelector((state) => state.loginUser.defaulttypesdi.default_contract_view_aut_tras);  
  const default_contract_view_aut_dest = useSelector((state) => state.loginUser.defaulttypesdi.default_contract_view_aut_dest);  
  const default_conditions_contract = useSelector((state) => state.loginUser.defaulttypesdi.default_conditions_contract);  
  const default_obligations_contract = useSelector((state) => state.loginUser.defaulttypesdi.default_obligations_contract);  
  const LIMITCODELERSCONTRACT = useSelector((state) => state.loginUser.defaulttypesdi.limitcodelerscontract);   
  const signature_default = useSelector((state) => state.formatDIUser.signature_default);
  const [formContract, setFormContract] = useState(initialStateContract);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingErrorData, setIsLoadingErrorData] = useState(false);
  const [errorsForm, setErrorsForm] = useState({});
  const [documentTypesToSelect,setDocumentTypesToSelect]= useState(initialDocumentTypesToSelect); 
  const [roadTypesToSelect,setRoadTypesToSelect]= useState(initialRDToSelect);
  const [optTypeToSelect,setOptTypeToSelect]= useState(initialRDToSelect);
  const [communityToSelect,setCommunityToSelect]= useState(initialRDToSelect); 
  const [expanded, setExpanded] =  useState(false); 
  const [openDeleteRowCodeLERS, setOpenDeleteRowCodeLERS] = useState(false);
  const [openEditRowCodeLERS, setOpenEditRowCodeLERS] = useState(false);
  const [openCreateEditRowCodeLERS, setOpenCreateEditRowCodeLERS] = useState(false);
  const [editRowCodeLER, setEditRowCodeLER] = useState(initialCodeLERToSelect);
  const [idCodeDeleteCodeLER,setIdCodeDeleteCodeLER]=useState(DELETE_CODE);
  const signDispatchedOptTrasCanvas = useRef(null);
  const signDispatchedOriTrasCanvas = useRef(null);
  const signDispatchedDestTrasCanvas = useRef(null);
 
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
 
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  }; 
  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalContractSettings) {
        setFormContract(initialStateContract);
        setFormContract(formContract => ({
          ...formContract,
          codelers:[]
        })); 
        setIsLoadingErrorData(false);
        setErrorsForm({});
        setDocumentTypesToSelect(initialDocumentTypesToSelect);
        setRoadTypesToSelect(initialRDToSelect);
        setOptTypeToSelect(initialRDToSelect);
        setCommunityToSelect(initialRDToSelect); 
        setExpanded(false);
        setOpenDeleteRowCodeLERS(false);
        setOpenEditRowCodeLERS(false);
        setOpenCreateEditRowCodeLERS(false);
        setEditRowCodeLER(initialCodeLERToSelect);
        setIdCodeDeleteCodeLER(DELETE_CODE); 
        dispatch(setLoading(false));
        if (signDispatchedOptTrasCanvas.current) signDispatchedOptTrasCanvas.current.clear();
        if (signDispatchedOriTrasCanvas.current) signDispatchedOriTrasCanvas.current.clear();
        if (signDispatchedDestTrasCanvas.current) signDispatchedDestTrasCanvas.current.clear();
        navigate("/contract");
        return () => {};
      }
    },
    [
      setFormContract, 
      setIsLoadingErrorData,
      setErrorsForm,
      setDocumentTypesToSelect,
      setRoadTypesToSelect,
      setCommunityToSelect,
      setExpanded,
      setOpenDeleteRowCodeLERS,
      setOpenEditRowCodeLERS,
      setOptTypeToSelect,
      setOpenCreateEditRowCodeLERS,
      setEditRowCodeLER,
      setIdCodeDeleteCodeLER, 
      showModalContractSettings,
      navigate,
      dispatch,
      DELETE_CODE]
  );
  
  const handleCloseDataEditContract = () => {
    setFormContract(initialStateContract);
    setFormContract(formContract => ({
      ...formContract,
      codelers:[]
    })); 
    setIsLoadingErrorData(false);
    setErrorsForm({});
    setDocumentTypesToSelect(initialDocumentTypesToSelect);
    setRoadTypesToSelect(initialRDToSelect);
    setOptTypeToSelect(initialRDToSelect);
    setCommunityToSelect(initialRDToSelect);
    setExpanded(false);
    setOpenDeleteRowCodeLERS(false);
    setOpenEditRowCodeLERS(false);
    setOpenCreateEditRowCodeLERS(false);
    setEditRowCodeLER(initialCodeLERToSelect);
    setIdCodeDeleteCodeLER(DELETE_CODE); 
    dispatch(setLoading(false));
    if (signDispatchedOptTrasCanvas.current) signDispatchedOptTrasCanvas.current.clear();
    if (signDispatchedOriTrasCanvas.current) signDispatchedOriTrasCanvas.current.clear();
    if (signDispatchedDestTrasCanvas.current) signDispatchedDestTrasCanvas.current.clear();
    navigate("/contract") ;
    return () => {};
	}; 

  const drawSignatureCentered = (canvasRef, base64) => {
    if (!canvasRef?.current || !base64) return;
    const canvas = canvasRef.current.getCanvas();
    const ctx = canvas.getContext("2d");
    // 🔒 Forzar tamaño interno fijo
    canvas.width = CANVAS_SIZE;
    canvas.height = CANVAS_SIZE;
    ctx.clearRect(0, 0, CANVAS_SIZE, CANVAS_SIZE);
    const img = new Image();
    img.src = base64;
    img.onload = () => {
      const imgWidth = img.width;
      const imgHeight = img.height;
      const scale = Math.min(
        CANVAS_SIZE / imgWidth,
        CANVAS_SIZE / imgHeight
      );
      const drawWidth = imgWidth * scale;
      const drawHeight = imgHeight * scale;
      const x = (CANVAS_SIZE - drawWidth) / 2;
      const y = (CANVAS_SIZE - drawHeight) / 2;
      ctx.drawImage(img, x, y, drawWidth, drawHeight);
    };
  };
   
  const handleSetSignatureOpt_tras = () => {
    if (!signDispatchedOptTrasCanvas.current) return;
    const canvasRef = signDispatchedOptTrasCanvas.current;
    const canvas = canvasRef.getCanvas();
    const ctx = canvas.getContext("2d");
    canvas.width = CANVAS_SIZE;
    canvas.height = CANVAS_SIZE;
    ctx.clearRect(0, 0, CANVAS_SIZE, CANVAS_SIZE);
    const img = new Image();
    img.src = defaultsignature;
    img.onload = () => {
      const imgWidth = img.width;
      const imgHeight = img.height;
      const scale = Math.min(
        CANVAS_SIZE / imgWidth,
        CANVAS_SIZE / imgHeight
      );
      const drawWidth = imgWidth * scale;
      const drawHeight = imgHeight * scale;
      const x = (CANVAS_SIZE - drawWidth) / 2;
      const y = (CANVAS_SIZE - drawHeight) / 2;
      ctx.drawImage(img, x, y, drawWidth, drawHeight);
      const base64 = canvasRef
        .getTrimmedCanvas()
        .toDataURL("image/png");
      setFormContract(formContract => ({
        ...formContract,
        signature_opt_tras: base64
      }));
    };
  };

  const handleSetSignatureOri_tras = () => {
    if (!signDispatchedOriTrasCanvas.current) return;
    const canvasRef = signDispatchedOriTrasCanvas.current;
    const canvas = canvasRef.getCanvas();
    const ctx = canvas.getContext("2d");
    canvas.width = CANVAS_SIZE;
    canvas.height = CANVAS_SIZE;
    ctx.clearRect(0, 0, CANVAS_SIZE, CANVAS_SIZE);
    const img = new Image();
    img.src = defaultsignature;
    img.onload = () => {
      const imgWidth = img.width;
      const imgHeight = img.height;
      const scale = Math.min(
        CANVAS_SIZE / imgWidth,
        CANVAS_SIZE / imgHeight
      );
      const drawWidth = imgWidth * scale;
      const drawHeight = imgHeight * scale;
      const x = (CANVAS_SIZE - drawWidth) / 2;
      const y = (CANVAS_SIZE - drawHeight) / 2;
      ctx.drawImage(img, x, y, drawWidth, drawHeight);
      const base64 = canvasRef
        .getTrimmedCanvas()
        .toDataURL("image/png");
      setFormContract(formContract => ({
        ...formContract,
        signature_ori_tras: base64
      }));
    };
  };

  const handleSetSignatureDest_tras = () => {
    if (!signDispatchedDestTrasCanvas.current) return;
    const canvasRef = signDispatchedDestTrasCanvas.current;
    const canvas = canvasRef.getCanvas();
    const ctx = canvas.getContext("2d");
    canvas.width = CANVAS_SIZE;
    canvas.height = CANVAS_SIZE;
    ctx.clearRect(0, 0, CANVAS_SIZE, CANVAS_SIZE);
    const img = new Image();
    img.src = defaultsignature;
    img.onload = () => {
      const imgWidth = img.width;
      const imgHeight = img.height;
      const scale = Math.min(
        CANVAS_SIZE / imgWidth,
        CANVAS_SIZE / imgHeight
      );
      const drawWidth = imgWidth * scale;
      const drawHeight = imgHeight * scale;
      const x = (CANVAS_SIZE - drawWidth) / 2;
      const y = (CANVAS_SIZE - drawHeight) / 2;
      ctx.drawImage(img, x, y, drawWidth, drawHeight);
      const base64 = canvasRef
        .getTrimmedCanvas()
        .toDataURL("image/png");
      setFormContract(formContract => ({
        ...formContract,
        signature_dest_tras: base64
      }));
    };
  };

  const deleteSignature = (id) => {
    switch (id) {
      case 1:   
        if (signDispatchedOptTrasCanvas.current) signDispatchedOptTrasCanvas.current.clear();
        setFormContract(formContract => ({
          ...formContract,
          signature_opt_tras: "",
        }));
        break;
      case 2:    
        if (signDispatchedOriTrasCanvas.current) signDispatchedOriTrasCanvas.current.clear();
        setFormContract(formContract => ({
          ...formContract,
          signature_ori_tras: "",
        }));
        break;
      case 3:    
        if (signDispatchedDestTrasCanvas.current) signDispatchedDestTrasCanvas.current.clear();
        setFormContract(formContract => ({
          ...formContract,
          signature_dest_tras: "",
        }));
        break; 
      default:
        break;
    } 
  }; 
  
  const handleChangeOpttrasBilling = (e) => {
    let checkBilling=!formContract.opttrasbilling;
    setFormContract(formContract => ({
      ...formContract,
      opttrasbilling: checkBilling,
      oritrasbilling:false,
      desttrasbilling:!checkBilling,
      reltransbilling:false
    }));
  };

  const handleChangeOritrasBilling = (e) => {
    let checkBilling=!formContract.oritrasbilling;
    setFormContract(formContract => ({
      ...formContract,
      opttrasbilling: false,
      oritrasbilling:checkBilling,
      desttrasbilling:!checkBilling,
      reltransbilling:false
    })); 
  };

  const handleChangeDesttrasBilling = (e) => {
    let checkBilling=!formContract.desttrasbilling;
    setFormContract(formContract => ({
      ...formContract,
      opttrasbilling: !checkBilling,
      oritrasbilling:false,
      desttrasbilling:checkBilling,
      reltransbilling:!false
    }));
  };

  const handleChangeDataEditContract = (e) => {
    const { name, value } = e.target;
    setFormContract(formContract => ({
      ...formContract,
      [name]: value,
    }));
  };
   
  const handleBlurDataEditContract = (e) => {
    handleChangeDataEditContract(e);
    setErrorsForm(validateFormContract());
  };

  const handleChangeSelectDate = (event) => {
    setFormContract(formContract => ({
      ...formContract,
      date_contract: event!==null?new Date(event):null
    }));
  };

  const handleBlurSelectDate = (e) => {
    handleChangeSelectDate(e);
    setErrorsForm(validateFormContract());
  };
  
  const withValueCap = (inputObj) => {
    const { value } = inputObj;
    if (value <= 10000000000) return true;
    return false;
  };

  const handleChangeDataEditContractAmount = (e) => {
    const { name, value } = e.target;
    let newValue=value!==null?Number((value.toLocaleString()).replaceAll(",","")):0;
    setFormContract(formContract => ({
      ...formContract,
      [name]: newValue,
    }));
  };

  const handleBlurDataEditContractAmount = (e) => {
    handleChangeDataEditContractAmount(e);
    setErrorsForm(validateFormContract());
  };
 
  const handleCancelDeleteRowCodeLER = () => {
    setIdCodeDeleteCodeLER(DELETE_CODE);
    setOpenDeleteRowCodeLERS(false);
  };

  const handleChangeDeleteRowCodeLER = (e) => {
    const value  = e.target.value;
    setIdCodeDeleteCodeLER(value);
  };

  const handleCloseDeleteRowCodeLER = (e) => {
    e.preventDefault();
    if (idCodeDeleteCodeLER!==DELETE_CODE){
      dispatch(warningErrorAction(t('Text_InvalidCode')));
    } else {
      
      let indexDelete=formContract.codelers.findIndex(((item) => item.indexrowcodeler === editRowCodeLER.indexrowcodeler));
      if ( indexDelete !== -1 ) {
        formContract.codelers.splice( indexDelete, 1 );
      }
      setFormContract(formContract => ({
        ...formContract,
      }))
      setIdCodeDeleteCodeLER(DELETE_CODE);
      setOpenDeleteRowCodeLERS(false);
    }
  };

  const validateFormContract = () => {
    let errorsForm = {};
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    let regexEmail = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    
    if (regexInvalidCharacters.test(formContract.number_nt)) {
      errorsForm.number_nt = 'Text_TextNoValid';
    }
    if (formContract.date_contract==="") {
      errorsForm.date_contract = 'Text_FieldDateContractRequired';
    }
    if (regexInvalidCharacters.test(formContract.periodicity_contract)) {
      errorsForm.periodicity_contract = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.duration_contract)) {
      errorsForm.duration_contract = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.other_information_contract)) {
      errorsForm.other_information_contract = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.conditions_contract)) {
      errorsForm.conditions_contract = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.obligations_contract)) {
      errorsForm.obligations_contract = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formContract.opt_tras_documentid)) {
      errorsForm.opt_tras_documentid = 'Text_TextNoValid';
    }else{
      if (formContract.opt_tras_documentid==="") {
        errorsForm.opt_tras_documentid = 'Text_FieldDateOptTrasDocumentIDRequired';
      }
    }
    if (regexInvalidCharacters.test(formContract.opt_tras_tradename)) {
      errorsForm.opt_tras_tradename = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.opt_tras_name)) {
      errorsForm.opt_tras_name = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.opt_tras_contactname)) {
      errorsForm.opt_tras_contactname = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.opt_tras_nima)) {
      errorsForm.opt_tras_nima = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.opt_tras_inscription)) {
      errorsForm.opt_tras_inscription = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formContract.opt_tras_grnp)) {
      errorsForm.opt_tras_grnp = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formContract.opt_tras_phone)) {
      errorsForm.opt_tras_phone = 'Text_TextNoValid';
    }
    if (formContract.opt_tras_email!=="" && regexEmail.test(formContract.opt_tras_email)) {
      errorsForm.opt_tras_email = 'Text_Email_Invalid';
    }
    if (regexInvalidCharacters.test(formContract.opt_tras_street)) {
      errorsForm.opt_tras_street = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.opt_tras_street_fiscal)) {
      errorsForm.opt_tras_street_fiscal = 'Text_TextNoValid';
    }   
    if (regexInvalidCharacters.test(formContract.ori_tras_documentid)) {
      errorsForm.ori_tras_documentid = 'Text_TextNoValid';
    }else{
      if (formContract.ori_tras_documentid==="") {
        errorsForm.ori_tras_documentid = 'Text_FieldDateOriTrasDocumentIDRequired';
      }
    }
    if (regexInvalidCharacters.test(formContract.ori_tras_tradename)) {
      errorsForm.ori_tras_tradename = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.ori_tras_name)) {
      errorsForm.ori_tras_name = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.ori_tras_contactname_documentid)) {
      errorsForm.ori_tras_contactname_documentid = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.ori_tras_contactname_name)) {
      errorsForm.ori_tras_contactname_name = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.ori_tras_contactname_position)) {
      errorsForm.ori_tras_contactname_position = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.ori_tras_contactname_email)) {
      errorsForm.ori_tras_contactname_email = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.ori_tras_contactname_phone)) {
      errorsForm.ori_tras_contactname_phone = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.ori_tras_nima)) {
      errorsForm.ori_tras_nima = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.ori_tras_inscription)) {
      errorsForm.ori_tras_inscription = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formContract.ori_tras_grnp)) {
      errorsForm.ori_tras_grnp = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formContract.ori_tras_street)) {
      errorsForm.ori_tras_street = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.ori_tras_phone)) {
      errorsForm.ori_tras_phone = 'Text_TextNoValid';
    }
    if (formContract.ori_tras_email!=="" && regexEmail.test(formContract.ori_tras_email)) {
      errorsForm.ori_tras_email = 'Text_Email_Invalid';
    } 
    if (regexInvalidCharacters.test(formContract.aut_tras_documentid)) {
      errorsForm.aut_tras_documentid = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.aut_tras_tradename)) {
      errorsForm.aut_tras_tradename = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.aut_tras_name)) {
      errorsForm.aut_tras_name = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.aut_tras_contactname)) {
      errorsForm.aut_tras_contactname = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.aut_tras_nima)) {
      errorsForm.aut_tras_nima = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formContract.aut_tras_inscription)) {
      errorsForm.aut_tras_inscription = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formContract.aut_tras_grnp)) {
      errorsForm.aut_tras_grnp = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formContract.aut_tras_street)) {
      errorsForm.aut_tras_street = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.aut_tras_phone)) {
      errorsForm.aut_tras_phone = 'Text_TextNoValid';
    }
    if (formContract.aut_tras_email!=="" && regexEmail.test(formContract.aut_tras_email)) {
      errorsForm.aut_tras_email = 'Text_Email_Invalid';
    } 
    if (regexInvalidCharacters.test(formContract.dest_tras_documentid)) {
      errorsForm.dest_tras_documentid = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.dest_tras_tradename)) {
      errorsForm.dest_tras_tradename = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.dest_tras_name)) {
      errorsForm.dest_tras_name = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.dest_tras_contactname)) {
      errorsForm.dest_tras_contactname = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.dest_tras_contactname_position)) {
      errorsForm.dest_tras_contactname_position = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.dest_tras_nima)) {
      errorsForm.dest_tras_nima = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.dest_tras_inscription)) {
      errorsForm.dest_tras_inscription = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formContract.dest_tras_grnp)) {
      errorsForm.dest_tras_grnp = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formContract.dest_tras_street)) {
      errorsForm.dest_tras_street = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.dest_tras_phone)) {
      errorsForm.dest_tras_phone = 'Text_TextNoValid';
    }
    if (formContract.dest_tras_email!=="" && regexEmail.test(formContract.dest_tras_email)) {
      errorsForm.dest_tras_email = 'Text_Email_Invalid';
    } 
    if (regexInvalidCharacters.test(formContract.dest_tras_street_fiscal)) {
      errorsForm.dest_tras_street_fiscal = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.aut_dest_documentid)) {
      errorsForm.aut_dest_documentid = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.aut_dest_tradename)) {
      errorsForm.aut_dest_tradename = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.aut_dest_name)) {
      errorsForm.aut_dest_name = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.aut_dest_contactname)) {
      errorsForm.aut_dest_contactname = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.aut_dest_nima)) {
      errorsForm.aut_dest_nima = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.aut_dest_inscription)) {
      errorsForm.aut_dest_inscription = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formContract.aut_dest_grnp)) {
      errorsForm.aut_dest_grnp = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formContract.dest_tras_grnp)) {
      errorsForm.dest_tras_grnp = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formContract.aut_dest_phone)) {
      errorsForm.aut_dest_phone = 'Text_TextNoValid';
    }
    if (formContract.aut_dest_email!=="" && regexEmail.test(formContract.aut_dest_email)) {
      errorsForm.aut_dest_email = 'Text_Email_Invalid';
    }
    if (regexInvalidCharacters.test(formContract.opt_tras_postalcode_code)) {
      errorsForm.opt_tras_postalcode_code = 'Text_TextNoValid';
    }else{
      if (formContract.opt_tras_documentid!=="" && formContract.opt_tras_street!==""){
        if (formContract.opt_tras_postalcode_code===undefined || formContract.opt_tras_postalcode_code===null || formContract.opt_tras_postalcode_code===""){
          errorsForm.opt_tras_postalcode_code='Text_Field_POSTALCODE_Opt_Tras_Required';
        }
      }
    }
    if (regexInvalidCharacters.test(formContract.ori_tras_postalcode_code)) {
      errorsForm.ori_tras_postalcode_code = 'Text_TextNoValid';
    }else{
      if (formContract.ori_tras_documentid!=="" && formContract.ori_tras_street!==""){
        if (formContract.ori_tras_postalcode_code===undefined || formContract.ori_tras_postalcode_code===null || formContract.ori_tras_postalcode_code===""){
          errorsForm.ori_tras_postalcode_code='Text_Field_POSTALCODE_Ori_Tras_Required';
        }
      }
    }
    if (regexInvalidCharacters.test(formContract.aut_tras_postalcode_code)) {
      errorsForm.aut_tras_postalcode_code = 'Text_TextNoValid';
    }else{
      if (formContract.aut_tras_documentid!=="" && formContract.aut_tras_street!==""){
        if (formContract.aut_tras_postalcode_code===undefined || formContract.aut_tras_postalcode_code===null || formContract.aut_tras_postalcode_code===""){
          errorsForm.aut_tras_postalcode_code='Text_Field_POSTALCODE_Aut_Tras_Required';
        }
      }
    }
    if (regexInvalidCharacters.test(formContract.dest_tras_postalcode_code)) {
      errorsForm.dest_tras_postalcode_code = 'Text_TextNoValid';
    }else{
      if (formContract.dest_tras_documentid!=="" && formContract.dest_tras_street!==""){
        if (formContract.dest_tras_postalcode_code===undefined || formContract.dest_tras_postalcode_code===null || formContract.dest_tras_postalcode_code===""){
          errorsForm.dest_tras_postalcode_code='Text_Field_POSTALCODE_Dest_Tras_Required';
        }
      }
    }

    return errorsForm;
  };

  const handleConfirmFetchDataEditContract = (dataToSend) => {
    const fetchData = async () => { 
      handleCloseDataEditContract(); 
      try {
        const getData = id !== "0"
          ? await helpHttp().put(ENDPOINT, `contract/updatecontract`, token, dataToSend)
          : await helpHttp().post(ENDPOINT, `contract/savecontract`, token, dataToSend);
        if (getData.status === "OK") {
          dispatch(successErrorAction(t('Text_SaveData')));
        } else {
          dispatch(warningErrorAction(t(getData.cause)));
        } 
      } catch (error) { 
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }   
      return () => {  };
    }; 
    fetchData();  
  };
 
  const handleSubmitDataEditContract = () => {
    const errors = validateFormContract();
    setErrorsForm(errors);
    if (Object.keys(errors).length === 0 && formContract.date_contract !== ''
        && formContract.opt_tras_documentid !== ''
        && formContract.ori_tras_documentid !== '') {  
          
      let signatureOpt_tras = formContract.signature_opt_tras;
      let signatureOri_tras = formContract.signature_ori_tras;
      let signatureDest_tras = formContract.signature_dest_tras;

      if (signDispatchedOptTrasCanvas.current && !signDispatchedOptTrasCanvas.current.isEmpty()) {
        signatureOpt_tras = signDispatchedOptTrasCanvas.current.getTrimmedCanvas().toDataURL("image/png");
      }

      if (signDispatchedOriTrasCanvas.current && !signDispatchedOriTrasCanvas.current.isEmpty()) {
        signatureOri_tras = signDispatchedOriTrasCanvas.current.getTrimmedCanvas().toDataURL("image/png");
      }
      if (signDispatchedDestTrasCanvas.current && !signDispatchedDestTrasCanvas.current.isEmpty()) {
        signatureDest_tras = signDispatchedDestTrasCanvas.current.getTrimmedCanvas().toDataURL("image/png");
      }
       const formToSend = {
        ...formContract,
        signature_opt_tras: signatureOpt_tras,
        signature_ori_tras: signatureOri_tras,
        signature_dest_tras: signatureDest_tras
      };

       setFormContract(formContract => ({
        ...formContract,
        signature_opt_tras: signatureOpt_tras,
        signature_ori_tras: signatureOri_tras,
        signature_dest_tras: signatureDest_tras
      })); 
      handleConfirmFetchDataEditContract(formToSend); 
    } else {
        if (errors.preiddoc_sheet) {
            dispatch(warningErrorAction(t(errors.preiddoc_sheet)));
          } else if (errors.date_contract) {
            dispatch(warningErrorAction(t(errors.date_contract)));
          } else if (errors.opt_tras_documentid) {
            dispatch(warningErrorAction(t(errors.opt_tras_documentid)));
          } else if (errors.opt_tras_tradename) {
            dispatch(warningErrorAction(t(errors.opt_tras_tradename)));
          } else if (errors.opt_tras_name) {
            dispatch(warningErrorAction(t(errors.opt_tras_name)));
          } else if (errors.opt_tras_contactname) {
            dispatch(warningErrorAction(t(errors.opt_tras_contactname)));
          } else if (errors.opt_tras_street) {
            dispatch(warningErrorAction(t(errors.opt_tras_street)));
          } else if (errors.opt_tras_postalcode_code) {
            dispatch(warningErrorAction(t(errors.opt_tras_postalcode_code)));
          } else if (errors.opt_tras_phone) {
            dispatch(warningErrorAction(t(errors.opt_tras_phone)));
          } else if (errors.opt_tras_email) {
            dispatch(warningErrorAction(t(errors.opt_tras_email)));
          } else if (errors.opt_tras_nima) {
            dispatch(warningErrorAction(t(errors.opt_tras_nima)));
          } else if (errors.opt_tras_grnp) {
            dispatch(warningErrorAction(t(errors.opt_tras_grnp)));
          } else if (errors.opt_tras_inscription) {
            dispatch(warningErrorAction(t(errors.opt_tras_inscription)));
          } else if (errors.ori_tras_documentid) {
            dispatch(warningErrorAction(t(errors.ori_tras_documentid)));
          } else if (errors.ori_tras_tradename) {
            dispatch(warningErrorAction(t(errors.ori_tras_tradename)));
          } else if (errors.ori_tras_name) {
            dispatch(warningErrorAction(t(errors.ori_tras_name)));
          } else if (errors.ori_tras_contactname) {
            dispatch(warningErrorAction(t(errors.ori_tras_contactname)));
          } else if (errors.ori_tras_street) {
            dispatch(warningErrorAction(t(errors.ori_tras_street)));
          } else if (errors.ori_tras_postalcode_code) {
            dispatch(warningErrorAction(t(errors.ori_tras_postalcode_code)));
          } else if (errors.ori_tras_phone) {
            dispatch(warningErrorAction(t(errors.ori_tras_phone)));
          } else if (errors.ori_tras_email) {
            dispatch(warningErrorAction(t(errors.ori_tras_email)));
          } else if (errors.ori_tras_nima) {
            dispatch(warningErrorAction(t(errors.ori_tras_nima)));
          } else if (errors.ori_tras_grnp) {
            dispatch(warningErrorAction(t(errors.ori_tras_grnp)));
          } else if (errors.ori_tras_inscription) {
            dispatch(warningErrorAction(t(errors.ori_tras_inscription)));
          } else if (errors.aut_tras_documentid) {
            dispatch(warningErrorAction(t(errors.aut_tras_documentid)));
          } else if (errors.aut_tras_tradename) {
            dispatch(warningErrorAction(t(errors.aut_tras_tradename)));
          } else if (errors.aut_tras_name) {
            dispatch(warningErrorAction(t(errors.aut_tras_name)));
          } else if (errors.aut_tras_contactname) {
            dispatch(warningErrorAction(t(errors.aut_tras_contactname)));
          } else if (errors.aut_tras_street) {
            dispatch(warningErrorAction(t(errors.aut_tras_street)));
          } else if (errors.aut_tras_postalcode_code) {
            dispatch(warningErrorAction(t(errors.aut_tras_postalcode_code)));
          } else if (errors.aut_tras_phone) {
            dispatch(warningErrorAction(t(errors.aut_tras_phone)));
          } else if (errors.aut_tras_email) {
            dispatch(warningErrorAction(t(errors.aut_tras_email)));
          } else if (errors.aut_tras_nima) {
            dispatch(warningErrorAction(t(errors.aut_tras_nima)));
          } else if (errors.aut_tras_grnp) {
            dispatch(warningErrorAction(t(errors.aut_tras_grnp)));
          } else if (errors.aut_tras_inscription) {
            dispatch(warningErrorAction(t(errors.aut_tras_inscription)));
          } else if (errors.dest_tras_documentid) {
            dispatch(warningErrorAction(t(errors.dest_tras_documentid)));
          } else if (errors.dest_tras_tradename) {
            dispatch(warningErrorAction(t(errors.dest_tras_tradename)));
          } else if (errors.dest_tras_name) {
            dispatch(warningErrorAction(t(errors.dest_tras_name)));
          } else if (errors.dest_tras_contactname) {
            dispatch(warningErrorAction(t(errors.dest_tras_contactname)));
          } else if (errors.dest_tras_street) {
            dispatch(warningErrorAction(t(errors.dest_tras_street)));
          } else if (errors.dest_tras_street) {
            dispatch(warningErrorAction(t(errors.dest_tras_street_fiscal)));
          } else if (errors.dest_tras_postalcode_code) {
            dispatch(warningErrorAction(t(errors.dest_tras_postalcode_code)));
          } else if (errors.dest_tras_phone) {
            dispatch(warningErrorAction(t(errors.dest_tras_phone)));
          } else if (errors.dest_tras_email) {
            dispatch(warningErrorAction(t(errors.dest_tras_email)));
          } else if (errors.dest_tras_nima) {
            dispatch(warningErrorAction(t(errors.dest_tras_nima)));
          } else if (errors.dest_tras_grnp) {
            dispatch(warningErrorAction(t(errors.dest_tras_grnp)));
          } else if (errors.dest_tras_inscription) {
            dispatch(warningErrorAction(t(errors.dest_tras_inscription)));
          } else if (errors.aut_dest_documentid) {
            dispatch(warningErrorAction(t(errors.aut_dest_documentid)));
          } else if (errors.aut_dest_tradename) {
            dispatch(warningErrorAction(t(errors.aut_dest_tradename)));
          } else if (errors.aut_dest_name) {
            dispatch(warningErrorAction(t(errors.aut_dest_name)));
          } else if (errors.aut_dest_contactname) {
            dispatch(warningErrorAction(t(errors.aut_dest_contactname)));
          } else if (errors.aut_dest_street) {
            dispatch(warningErrorAction(t(errors.aut_dest_street)));
          } else if (errors.aut_dest_postalcode_code) {
            dispatch(warningErrorAction(t(errors.aut_dest_postalcode_code)));
          } else if (errors.aut_dest_phone) {
            dispatch(warningErrorAction(t(errors.aut_dest_phone)));
          } else if (errors.aut_dest_email) {
            dispatch(warningErrorAction(t(errors.aut_dest_email)));
          } else if (errors.aut_dest_nima) {
            dispatch(warningErrorAction(t(errors.aut_dest_nima)));
          } else if (errors.aut_dest_grnp) {
            dispatch(warningErrorAction(t(errors.aut_dest_grnp)));
          } else if (errors.aut_dest_inscription) {
            dispatch(warningErrorAction(t(errors.aut_dest_inscription)));
          } else if (errors.periodicity_contract) {
            dispatch(warningErrorAction(t(errors.periodicity_contract)));
          } else if (errors.duration_contract) {
            dispatch(warningErrorAction(t(errors.duration_contract)));
          } else if (errors.other_information_contract) {
            dispatch(warningErrorAction(t(errors.other_information_contract)));
          } else if (errors.conditions_contract) {
            dispatch(warningErrorAction(t(errors.conditions_contract)));
          } else if (errors.obligations_contract) {
              dispatch(warningErrorAction(t(errors.obligations_contract)));
          } else {
            dispatch(warningErrorAction(t('Text_IncorrectData')));
          } 
    }
  }; 

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    let isMounted = true;

    const fetchDataRoadType = async () => {
      try {
        const getData = i18n.language === "es"
          ? await helpHttp().get(ENDPOINT, `roadtype/roadtypesorderbynamees`, token)
          : await helpHttp().get(ENDPOINT, `roadtype/roadtypesorderbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setRoadTypesToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchDataOptType = async () => {
      try {
        const getData = i18n.language === "es"
          ? await helpHttp().get(ENDPOINT, `opttype/opttypesorderbynamees`, token)
          : await helpHttp().get(ENDPOINT, `opttype/opttypesorderbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setOptTypeToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchDataCommunity = async () => {
      try {
        const getData = i18n.language === "es"
        ? await helpHttp().get(ENDPOINT, `community/simplecommunitiesbynamees`, token)
        : await helpHttp().get(ENDPOINT, `community/simplecommunitiesbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setCommunityToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
  
    const fetchDataDocumentType = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `documenttype/simpledocumenttypesbyname`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setDocumentTypesToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
    if (formContract.id!==null){
      fetchDataDocumentType();
      fetchDataRoadType();
      fetchDataOptType();
      fetchDataCommunity(); 
    }
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,formContract.id,showModalContractSettings]);
  
  const isValidPngDataURL = (value) => {
    if (typeof value !== "string") return false;
    const trimmed = value.trim();
    if (trimmed==="") return false;
    if (trimmed.includes("static/media")) return true; 
    if (!trimmed.startsWith("data:image/png;base64,")) return false;
    // longitud mínima razonable para un PNG (ajusta si quieres)
    return trimmed.length > 200; 
  };

  useEffect(() => {
    let isMounted = true;
    const fetchDataForm = async () => { 
      try {
        const getData = await  helpHttp().get2(ENDPOINT,`contract/getcontractbyid/`,token,id);
        if (getData.err) {
          setFormContract(initialStateContract);
          setIsLoadingErrorData(true); 
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setFormContract(getData); 
          if (getData.signature_opt_tras && isValidPngDataURL(getData.signature_opt_tras)) {
            setTimeout(() => {
              if (signDispatchedOptTrasCanvas.current) {
                drawSignatureCentered(signDispatchedOptTrasCanvas, getData.signature_opt_tras);
              }
            }, 200);
          }  
          if (getData.signature_ori_tras && isValidPngDataURL(getData.signature_ori_tras)) {
            setTimeout(() => {
              if (signDispatchedOriTrasCanvas.current) {
                drawSignatureCentered(signDispatchedOriTrasCanvas, getData.signature_ori_tras);
              }
            }, 200);
          } 
          if (getData.signature_dest_tras && isValidPngDataURL(getData.signature_dest_tras)) {
            setTimeout(() => {
              if (signDispatchedDestTrasCanvas.current) {
                drawSignatureCentered(signDispatchedDestTrasCanvas, getData.signature_dest_tras);
              }
            }, 200);
          } 
        }  
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };

    if (id!=="0"){
      if (formContract.id===""){
        fetchDataForm();  
      }
    }else{
      setFormContract(initialStateContract);
      setFormContract(formContract => ({
        ...formContract,
        owncontract_id:0,
        defaultStore_id:defaultStore.id,
        useraccount_id:useraccount_id,
        defaultformatnumber:defaulttypesdi.formatnumber,
        number_nt:"",
        date_contract:"",
        amount_contract:0,
        periodicity_contract:"",
        duration_contract:"",
        other_information_contract:"",
        conditions_contract:default_conditions_contract,
        obligations_contract:default_obligations_contract,
 
        contractopttrasstore_id:0,
        opt_tras_store_id:defaulttypesdi.default_opt_tras_id  || 0,
        opt_tras_documnettype_id:defaulttypesdi.default_opt_tras_documnettype_id!==0?defaulttypesdi.default_opt_tras_documnettype_id:(DEFAULTTYPEOFDOCUMENT),
        opt_tras_documentid:defaulttypesdi.default_opt_tras_documentid || "",
        opt_tras_tradename:defaulttypesdi.default_opt_tras_tradename || "",
        opt_tras_name:defaulttypesdi.default_opt_tras_name || "",
        opt_tras_contactname:defaulttypesdi.default_opt_tras_contactname || "",
        opt_tras_nima:defaulttypesdi.default_opt_tras_nima || "",
        opt_tras_inscription:defaulttypesdi.default_opt_tras_inscription || "",
        opt_tras_grnp:"",
        opt_tras_opt:defaulttypesdi.default_opt_tras_opt  || 0,
        opt_tras_phone:defaulttypesdi.default_opt_tras_phone || "",
        opt_tras_email:defaulttypesdi.default_opt_tras_email || "",
        opt_tras_roadtype_id:defaulttypesdi.default_opt_tras_roadtype_id!==0?defaulttypesdi.default_opt_tras_roadtype_id: Number(DEFAULTROADTYE),
        opt_tras_street:defaulttypesdi.default_opt_tras_street || "",
        opt_tras_country_id:defaulttypesdi.default_opt_tras_country_id!==0?defaulttypesdi.default_opt_tras_country_id:Number(DEFAULTCOUNTRY),
        opt_tras_country_name:defaulttypesdi.default_opt_tras_country_name!==""?defaulttypesdi.default_opt_tras_country_name:DEFAULTCOUNTRY_NAME,
        opt_tras_province_id:defaulttypesdi.default_opt_tras_province_id!==0?defaulttypesdi.default_opt_tras_province_id:Number(DEFAULTPROVINCE),
        opt_tras_province_name:defaulttypesdi.default_opt_tras_province_name!==""?defaulttypesdi.default_opt_tras_province_name:DEFAULTPROVINCE_NAME,
        opt_tras_postalcode_id:defaulttypesdi.default_opt_tras_postalcode_id!==0?defaulttypesdi.default_opt_tras_postalcode_id:Number(DEFAULTPOSTALCODE_ID),
        opt_tras_postalcode_code:defaulttypesdi.default_opt_tras_postalcode_code!==""?defaulttypesdi.default_opt_tras_postalcode_code:DEFAULTPOSTALCODE_CODE,
        opt_tras_postalcode_name:defaulttypesdi.default_opt_tras_postalcode_name!==""?defaulttypesdi.default_opt_tras_postalcode_name:DEFAULTPOSTALCODE_NAME,
        opt_tras_community_id:defaulttypesdi.default_opt_tras_community_id!==0?defaulttypesdi.default_opt_tras_community_id:Number(DEFAULTCOMMUNITY),
        opt_tras_community_name:defaulttypesdi.default_opt_tras_community_name!==""?defaulttypesdi.default_opt_tras_community_id:DEFAULTCOMMUNITY_NAME,
        opt_tras_roadtype_id_fiscal:defaulttypesdi.default_opt_tras_roadtype_id!==0?defaulttypesdi.default_opt_tras_roadtype_id: Number(DEFAULTROADTYE),
        opt_tras_street_fiscal:defaulttypesdi.default_opt_tras_street || "",
        opt_tras_country_name_fiscal:defaulttypesdi.default_opt_tras_country_name!==""?defaulttypesdi.default_opt_tras_country_name:DEFAULTCOUNTRY_NAME,
        opt_tras_province_id_fiscal:defaulttypesdi.default_opt_tras_province_id!==0?defaulttypesdi.default_opt_tras_province_id:Number(DEFAULTPROVINCE),
        opt_tras_province_name_fiscal:defaulttypesdi.default_opt_tras_province_name!==""?defaulttypesdi.default_opt_tras_province_name:DEFAULTPROVINCE_NAME,
        opt_tras_postalcode_id_fiscal:defaulttypesdi.default_opt_tras_postalcode_id!==0?defaulttypesdi.default_opt_tras_postalcode_id:Number(DEFAULTPOSTALCODE_ID),
        opt_tras_postalcode_code_fiscal:defaulttypesdi.default_opt_tras_postalcode_code!==""?defaulttypesdi.default_opt_tras_postalcode_code:DEFAULTPOSTALCODE_CODE,
        opt_tras_postalcode_name_fiscal:defaulttypesdi.default_opt_tras_postalcode_name!==""?defaulttypesdi.default_opt_tras_postalcode_name:DEFAULTPOSTALCODE_NAME,
        opt_tras_community_id_fiscal:defaulttypesdi.default_opt_tras_community_id!==0?defaulttypesdi.default_opt_tras_community_id:Number(DEFAULTCOMMUNITY),
        opt_tras_community_name_fiscal:defaulttypesdi.default_opt_tras_community_name!==""?defaulttypesdi.default_opt_tras_community_id:DEFAULTCOMMUNITY_NAME,
          
        contractoritrasstore_id:0,
        ori_tras_store_id:0,
        ori_tras_documnettype_id:DEFAULTTYPEOFDOCUMENT,
        ori_tras_documentid: "",
        ori_tras_tradename: "",
        ori_tras_name: "",
        ori_tras_contactname_employee_id : "",
        ori_tras_contactname_documnettype_id : "",
        ori_tras_contactname_documentid : "",
        ori_tras_contactname_firstaname : "",
        ori_tras_contactname_lastname1 : "",
        ori_tras_contactname_lastname2 : "",
        ori_tras_contactname_position : "",
        ori_tras_contactname_email : "",
        ori_tras_contactname_phone : "",
        ori_tras_nima: "",
        ori_tras_inscription: "",
        ori_tras_grnp:"",
        ori_tras_opt: 0,
        ori_tras_phone: "",
        ori_tras_email: "",
        ori_tras_roadtype_id: Number(DEFAULTROADTYE),
        ori_tras_street:"",
        ori_tras_country_id:Number(DEFAULTCOUNTRY),
        ori_tras_country_name:DEFAULTCOUNTRY_NAME,
        ori_tras_province_id:Number(DEFAULTPROVINCE),
        ori_tras_province_name:DEFAULTPROVINCE_NAME,
        ori_tras_postalcode_id:Number(DEFAULTPOSTALCODE_ID),
        ori_tras_postalcode_code:DEFAULTPOSTALCODE_CODE,
        ori_tras_postalcode_name:DEFAULTPOSTALCODE_NAME,
        ori_tras_community_id:Number(DEFAULTCOMMUNITY),
        ori_tras_community_name:DEFAULTCOMMUNITY_NAME,      
        ori_tras_country_id_fiscal:Number(DEFAULTCOUNTRY),
        ori_tras_country_name_fiscal:DEFAULTCOUNTRY_NAME,
        ori_tras_province_id_fiscal:Number(DEFAULTPROVINCE),
        ori_tras_province_name_fiscal:DEFAULTPROVINCE_NAME,
        ori_tras_postalcode_id_fiscal:Number(DEFAULTPOSTALCODE_ID),
        ori_tras_postalcode_code_fiscal:DEFAULTPOSTALCODE_CODE,
        ori_tras_postalcode_name_fiscal:DEFAULTPOSTALCODE_NAME,
        ori_tras_community_id_fiscal:Number(DEFAULTCOMMUNITY),
        ori_tras_community_name_fiscal:DEFAULTCOMMUNITY_NAME,  
     
        aut_tras_store_id:0,
        aut_tras_documnettype_id:Number(DEFAULTTYPEOFDOCUMENT),
        aut_tras_documentid: "",
        aut_tras_tradename: "",
        aut_tras_name: "",
        aut_tras_contactname: "",
        aut_tras_nima: "",
        aut_tras_inscription: "",
        aut_tras_grnp:"",
        aut_tras_opt: 0,
        aut_tras_phone: "",
        aut_tras_email: "",
        aut_tras_roadtype_id: Number(DEFAULTROADTYE),
        aut_tras_street:"",
        aut_tras_country_id:Number(DEFAULTCOUNTRY),
        aut_tras_country_name:DEFAULTCOUNTRY_NAME,
        aut_tras_province_id:Number(DEFAULTPROVINCE),
        aut_tras_province_name:DEFAULTPROVINCE_NAME,
        aut_tras_postalcode_id:Number(DEFAULTPOSTALCODE_ID),
        aut_tras_postalcode_code:DEFAULTPOSTALCODE_CODE,
        aut_tras_postalcode_name:DEFAULTPOSTALCODE_NAME,
        aut_tras_community_id:Number(DEFAULTCOMMUNITY),
        aut_tras_community_name:DEFAULTCOMMUNITY_NAME,      

        contractdesttrasstore_id:0,
        dest_tras_store_id:0,
        dest_tras_documnettype_id:Number(DEFAULTTYPEOFDOCUMENT),
        dest_tras_documentid: "",
        dest_tras_tradename: "",
        dest_tras_name: "",
        dest_tras_contactname: "",
        dest_tras_contactname_position:"",
        dest_tras_nima: "",
        dest_tras_inscription: "",
        dest_tras_grnp: "",
        dest_tras_opt: 0,
        dest_tras_phone: "",
        dest_tras_email: "",
        dest_tras_roadtype_id: Number(DEFAULTROADTYE),
        dest_tras_street:"",
        dest_tras_country_id:Number(DEFAULTCOUNTRY),
        dest_tras_country_name:DEFAULTCOUNTRY_NAME,
        dest_tras_province_id:Number(DEFAULTPROVINCE),
        dest_tras_province_name:DEFAULTPROVINCE_NAME,
        dest_tras_postalcode_id:Number(DEFAULTPOSTALCODE_ID),
        dest_tras_postalcode_code:DEFAULTPOSTALCODE_CODE,
        dest_tras_postalcode_name:DEFAULTPOSTALCODE_NAME,
        dest_tras_community_id:Number(DEFAULTCOMMUNITY),
        dest_tras_community_name:DEFAULTCOMMUNITY_NAME,

        dest_tras_roadtype_id_fiscal: Number(DEFAULTROADTYE),
        dest_tras_street_fiscal:"",
        dest_tras_country_id_fiscal:Number(DEFAULTCOUNTRY),
        dest_tras_country_name_fiscal:DEFAULTCOUNTRY_NAME,
        dest_tras_province_id_fiscal:Number(DEFAULTPROVINCE),
        dest_tras_province_name_fiscal:DEFAULTPROVINCE_NAME,
        dest_tras_postalcode_id_fiscal:Number(DEFAULTPOSTALCODE_ID),
        dest_tras_postalcode_code_fiscal:DEFAULTPOSTALCODE_CODE,
        dest_tras_postalcode_name_fiscal:DEFAULTPOSTALCODE_NAME,
        dest_tras_community_id_fiscal:Number(DEFAULTCOMMUNITY),
        dest_tras_community_name_fiscal:DEFAULTCOMMUNITY_NAME,

        aut_dest_store_id:0,
        aut_dest_documnettype_id:Number(DEFAULTTYPEOFDOCUMENT),
        aut_dest_documentid: "",
        aut_dest_tradename: "",
        aut_dest_name: "",
        aut_dest_contactname: "",
        aut_dest_nima: "",
        aut_dest_inscription: "",
        aut_dest_grnp: "",
        aut_dest_opt: 0,
        aut_dest_phone: "",
        aut_dest_email: "",
        aut_dest_roadtype_id: Number(DEFAULTROADTYE),
        aut_dest_street:"",
        aut_dest_country_id:Number(DEFAULTCOUNTRY),
        aut_dest_country_name:DEFAULTCOUNTRY_NAME,
        aut_dest_province_id:Number(DEFAULTPROVINCE),
        aut_dest_province_name:DEFAULTPROVINCE_NAME,
        aut_dest_postalcode_id:Number(DEFAULTPOSTALCODE_ID),
        aut_dest_postalcode_code:DEFAULTPOSTALCODE_CODE,
        aut_dest_postalcode_name:DEFAULTPOSTALCODE_NAME,
        aut_dest_community_id:Number(DEFAULTCOMMUNITY),
        aut_dest_community_name:DEFAULTCOMMUNITY_NAME,
      
        opt_tras_shared:false,
        ori_tras_shared:false,
        aut_tras_shared:false,
        dest_tras_shared:false,
        aut_dest_shared:false,

        opttrasbilling:false,
        oritrasbilling:false,
        desttrasbilling:true,
        reltransbilling:false,

        sendbyemail_opt_tras:false,
        sendbyemail_ori_tras:false,
        sendbyemail_aut_tras:false,
        sendbyemail_dest_tras:false,
        sendbyemail_aut_dest:false,
      
        signature_opt_tras:signature_default,
        signature_ori_tras:"",
        signature_dest_tras:"",

        codelers:[] 

      })); 
    }
    return () => { isMounted = false };
  }, [dispatch,id,t,token,formContract.id,
    default_conditions_contract,default_obligations_contract,
    DEFAULTCOMMUNITY,DEFAULTCOUNTRY,defaulttypesdi,defaultStore.id,useraccount_id,isLoadingData,DEFAULTPROVINCE, DEFAULTTYPEOFDOCUMENT,
    DEFAULTCOMMUNITY_NAME,DEFAULTCOUNTRY_NAME,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPOSTALCODE_NAME,DEFAULTPROVINCE_NAME,DEFAULTROADTYE,
    signature_default]);  
 
  return (
      <>
        {showModalContractSettings ? ( 
          <div className="container-fluid formgeneral-send-wrapper">
            <Box sx={{ bgcolor: '#ffffff', width: '1056px'}}>
              <form onSubmit={handleCloseDataEditContract}>
                {/* HEADER */}
                <div className="formgeneral-card-header">
                  <div className="formgeneral-header-content">
                    <div className="formgeneral-header-title2">
                      {isLoadingErrorData?
                        <i className="fas fa-solid fa-exclamation fa-2x text-danger"/>:
                        (isLoadingData?
                        <CircularProgress sx={{ color : "#f6c23e"}}/>:
                        <i className="fas fa-regular fa-clipboard text-warning"></i>)} 
                        &nbsp;&nbsp;{id==="0"?t('Text_CONTRACT_New'):t('Text_CONTRACT_Edit')+': '+formContract.owncontract_id}
                    </div>
                    <div className="email-card-actions">
                      {!isLoadingData && (
                        <>
                          <button type="button" className="formgeneral-send-btn" onClick={handleSubmitDataEditContract} >
                            {id==="0"?t('Button_Create'):t('Button_Update')}
                          </button>
                          <button type="button" className="formgeneral-cancel-btn" onClick={handleCloseDataEditContract} >
                            {t('Button_Cancel')}
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <br/>
                  
                {/* FORM CARD */}
                {!isLoadingData ?
                <>
                  <div className="formgeneral-card-form">
                    <div className="row p-2"> 
                      <div className="form-group">    
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_NT_CONTRACT')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                            id="number_nt" 
                            name="number_nt"
                            value={formContract.number_nt}
                            inputProps={{ style: {width: i18n.language==='es'?396:407,  fontSize: '18px'}, maxLength: 30 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            label={errorsForm.number_nt!=null?t(errorsForm.number_nt):t('PlaceHolder_CONTRACT_NT_CONTRACT')}
                            placeholder={t('PlaceHolder_CONTRACT_NT_CONTRACT')}
                            variant="standard"
                            onBlur={handleBlurDataEditContract}
                            onChange={handleChangeDataEditContract}
                          />
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_DATE')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <DesktopDatePicker
                              id="date_contract" 
                              name="date_contract"
                              value={ formContract.date_contract!== null ? new Date(formContract.date_contract):null}
                              format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                              inputProps={{ style: {width: 250}, maxLength: 100 }}
                              label={errorsForm.date_contract!=null?t(errorsForm.date_contract):t('PlaceHolder_CONTRACT_DATE')}
                              onBlur={handleBlurSelectDate}
                              onChange={handleChangeSelectDate}
                              slotProps={{
                                textField: {
                                  placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                  sx: {
                                    maxLength: 250,
                                    width: 250,
                                    fontSize: '18px',  
                                  },
                                  InputProps: {
                                    style: {
                                      fontSize: '18px',
                                    }
                                  },
                                  InputLabelProps:{ 
                                    style: {
                                      fontSize: '18px', 
                                      background: '#FFFFFF'
                                    }
                                  },
                                },
                              }}
                            />
                          </LocalizationProvider>
                        </div>
                        <div className="form-group">   
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_AMOUNT_KG')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <NumericFormat 
                            thousandSeparator={','} 
                            decimalSeparator={'.'} 
                            decimalScale= {2}
                            fixedDecimalScale= {true}
                            allowNegative= {false}
                            isAllowed={withValueCap}
                            id="amount_contract" 
                            name="amount_contract"
                            value={formContract.amount_contract}
                            label={errorsForm.amount_contract!=null?t(errorsForm.amount_contract):t('PlaceHolder_CONTRACT_AMOUNT_KG')}
                            placeholder={t('PlaceHolder_CONTRACT_AMOUNT_KG')}
                            inputProps={{ style: {width: i18n.language==='es'?200:200,  fontSize: '18px'}, maxLength: 20 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            customInput={TextField}
                            onBlur={handleBlurDataEditContractAmount}
                            onChange={handleChangeDataEditContractAmount}
                          />
                        </div>
                        <div className="form-group">   
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_PERIODICITY')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                            id="periodicity_contract" 
                            name="periodicity_contract"
                            value={formContract.periodicity_contract}
                            inputProps={{ style: {width: i18n.language==='es'?460:529,  fontSize: '18px'}, maxLength: 20 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            label={errorsForm.periodicity_contract!=null?t(errorsForm.periodicity_contract):t('PlaceHolder_CONTRACT_PERIODICITY')}
                            placeholder={t('PlaceHolder_CONTRACT_PERIODICITY')}
                            variant="standard"
                            onBlur={handleBlurDataEditContract}
                            onChange={handleChangeDataEditContract}
                          />
                        </div>
                        <div className="form-group">  
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_DURATION')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                            id="duration_contract" 
                            name="duration_contract"
                            value={formContract.duration_contract}
                            inputProps={{ style: {width: i18n.language==='es'?846:850,  fontSize: '18px'}, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            label={errorsForm.duration_contract!=null?t(errorsForm.duration_contract):t('PlaceHolder_CONTRACT_DURATION')}
                            placeholder={t('PlaceHolder_CONTRACT_DURATION')}
                            variant="standard"
                            onBlur={handleBlurDataEditContract}
                            onChange={handleChangeDataEditContract}
                            /> 
                        </div>
                        <div className="form-group">   
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_INFORMATION')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                            id="other_information_contract" 
                            name="other_information_contract"
                            value={formContract.other_information_contract}
                            inputProps={{ style: {width: i18n.language==='es'?501:582,  fontSize: '18px'}, maxLength: 255 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            label={errorsForm.other_information_contract!=null?t(errorsForm.other_information_contract):t('PlaceHolder_CONTRACT_INFORMATION')}
                            placeholder={t('PlaceHolder_CONTRACT_INFORMATION')}
                            variant="standard"
                            onBlur={handleBlurDataEditContract}
                            onChange={handleChangeDataEditContract}
                          /> 
                        </div>
                        <div className="form-group"> 
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_CONDITIONS')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                              id="conditions_contract" 
                              name="conditions_contract"
                              value={formContract.conditions_contract}
                              inputProps={{ style: {width: i18n.language==='es'?710:748,  fontSize: '18px'}, maxLength: 255 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsForm.conditions_contract!=null?t(errorsForm.conditions_contract):t('PlaceHolder_CONTRACT_CONDITIONS')}
                              placeholder={t('PlaceHolder_CONTRACT_CONDITIONS')}
                              variant="standard"
                              onBlur={handleBlurDataEditContract}
                              onChange={handleChangeDataEditContract}
                          /> 
                        </div>
                        <div className="form-group"> 
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_OBLLIGATIONS')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                              id="obligations_contract" 
                              name="obligations_contract"
                              value={formContract.obligations_contract}
                              inputProps={{ style: {width: i18n.language==='es'?395:372,  fontSize: '18px'}, maxLength: 255 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              label={errorsForm.obligations_contract!=null?t(errorsForm.obligations_contract):t('PlaceHolder_CONTRACT_OBLLIGATIONS')}
                              placeholder={t('PlaceHolder_CONTRACT_OBLLIGATIONS')}
                              variant="standard"
                              onBlur={handleBlurDataEditContract}
                              onChange={handleChangeDataEditContract}
                            /> 
                        </div>
                        <div className="form-group"> 
                          <label className="text" style={{color:"#067330", fontSize: 18 }}>{t('Text_CONTRACT_BILLING')}</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <Checkbox  
                            style={{color:"#4e73df", fontSize: 18, paddingLeft:1}} 
                            id="opttrasbilling"
                            name="opttrasbilling"
                            checked={formContract.opttrasbilling} 
                            onChange={handleChangeOpttrasBilling} 
                            sx={{
                              '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                            }}
                          /> 
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_BILLING_OPT_TRAS')}</label>
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          <Checkbox  
                            style={{color:"#4e73df", fontSize: 18, paddingLeft:1}} 
                            id="oritrasbilling"
                            name="oritrasbilling"
                            checked={formContract.oritrasbilling} 
                            onChange={handleChangeOritrasBilling} 
                            sx={{
                              '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                            }}
                          /> 
                          <label className="text" style={{ color:"#4e73df",fontSize: 16 }}>{t('Text_CONTRACT_BILLING_ORI_TRAS')}</label>
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          <Checkbox  
                            style={{color:"#4e73df", fontSize: 18, paddingLeft:1}} 
                            id="desttrasbilling"
                            name="desttrasbilling"
                            checked={formContract.desttrasbilling} 
                            onChange={handleChangeDesttrasBilling} 
                            sx={{
                              '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                            }}
                          /> 
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_BILLING_DEST_TRAS')}</label>
                        </div> 
                      </div> 
                      <Accordion className="accordionOptTras-root" expanded={expanded === 'panel1'} onChange={handleChange('panel1')} >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1bh-content"
                          id="panel1bh-header"
                          className="accordionOptTras-backcolor"
                        >
                          <Typography className="accordionOptTras-heading">{t('Text_CONTRACT_OPT_TRAS')} :</Typography>
                          <Typography className="accordionOptTras-secondaryHeading">
                            {formContract.opt_tras_tradename!==undefined && formContract.opt_tras_tradename!==null && formContract.opt_tras_tradename!==""?formContract.opt_tras_tradename:t('Text_NOT_REPORTING')}                                    
                            {formContract.opt_tras_documentid!=="" && formContract.opt_tras_tradename===""?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_Tradename_Sheet_Required')} !!</span>:""}
                            {formContract.opt_tras_documentid!=="" && formContract.opt_tras_street!=="" && !formContract.opt_tras_postalcode_id?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_POSTALCODE_Opt_Tras_Required')} !!</span>:""}
                            {formContract.opt_tras_documentid!=="" && formContract.opt_tras_nima==="" ?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_NIMA_Opt_Tras_Required')} !!</span>:""}
                            {errorsForm.opt_tras_email!==undefined && errorsForm.opt_tras_email!==""?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Email_Sheet_Invalid')} !!</span>:""}
                            {(errorsForm.opt_tras_tradename!==undefined && errorsForm.opt_tras_tradename!=="") ||
                            (errorsForm.opt_tras_name!==undefined && errorsForm.opt_tras_name!=="") ||
                            (errorsForm.opt_tras_contactname!==undefined && errorsForm.opt_tras_contactname!=="") ||
                            (errorsForm.opt_tras_nima!==undefined && errorsForm.opt_tras_nima!=="") ||
                            (errorsForm.opt_tras_inscription!==undefined && errorsForm.opt_tras_inscription!=="") ||
                            (errorsForm.opt_tras_opt!==undefined && errorsForm.opt_tras_opt!=="") ||
                            (errorsForm.opt_tras_phone!==undefined && errorsForm.opt_tras_phone!=="") ||
                            (errorsForm.opt_tras_street!==undefined && errorsForm.opt_tras_street!=="") ||
                            (errorsForm.opt_tras_street_fiscal!==undefined && errorsForm.opt_tras_street_fiscal!=="")
                            ?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Character_Sheet_Invalid')} !!</span>:""}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className="accordion-inner-box">
                            <ContractCreateOrEditOptTras
                              formContract={formContract}
                              setFormContract={setFormContract}
                              setIsLoadingErrorData={setIsLoadingErrorData}
                              errorsForm={errorsForm}
                              setErrorsForm={setErrorsForm}
                              validateFormContract={validateFormContract}
                              documentTypesToSelect={documentTypesToSelect}
                              roadTypesToSelect={roadTypesToSelect}
                              communityToSelect={communityToSelect} 
                              expanded={expanded}
                              optTypeToSelect={optTypeToSelect}
                            />
                          </div>
                        </AccordionDetails>
                    </Accordion>
                     <Accordion className="accordionOptTras-root" expanded={expanded === 'panel2'} onChange={handleChange('panel2')} >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel2bh-content"
                          id="panel2bh-header"
                          className="accordionOptTras-backcolor"
                        >
                          <Typography className="accordionOptTras-heading">{t('Text_CONTRACT_ORI_TRAS')} :</Typography>
                          <Typography className="accordionOptTras-secondaryHeading">
                            {formContract.ori_tras_tradename!==undefined && formContract.ori_tras_tradename!==null && formContract.ori_tras_tradename!==""?formContract.ori_tras_tradename:t('Text_NOT_REPORTING')} 
                              {formContract.ori_tras_documentid!=="" && formContract.ori_tras_tradename===""?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_Tradename_Sheet_Required')} !!</span>:""}
                              {formContract.ori_tras_documentid!=="" && formContract.ori_tras_street!=="" && !formContract.ori_tras_postalcode_id?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_POSTALCODE_Ori_Tras_Required')} !!</span>:""}
                              {errorsForm.ori_tras_email!==undefined && errorsForm.ori_tras_email!==""?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Email_Sheet_Invalid')} !!</span>:""}
                              {(errorsForm.ori_tras_tradename!==undefined && errorsForm.ori_tras_tradename!=="") ||
                              (errorsForm.ori_tras_name!==undefined && errorsForm.ori_tras_name!=="") ||
                              (errorsForm.ori_tras_street!==undefined && errorsForm.ori_tras_street!=="") ||
                              (errorsForm.ori_tras_phone!==undefined && errorsForm.ori_tras_phone!=="") ||
                              (errorsForm.ori_tras_nima!==undefined && errorsForm.ori_tras_nima!=="") ||
                              (errorsForm.ori_tras_inscription!==undefined && errorsForm.ori_tras_inscription!=="") ||
                              (errorsForm.ori_tras_opt!==undefined && errorsForm.ori_tras_opt!=="")
                              ?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Character_Sheet_Invalid')} !!</span>:""}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className="accordion-inner-box">
                            <ContractCreateOrEditOriTras
                              formContract={formContract}
                              setFormContract={setFormContract}
                              setIsLoadingErrorData={setIsLoadingErrorData}
                              errorsForm={errorsForm}
                              setErrorsForm={setErrorsForm}
                              validateFormContract={validateFormContract}
                              documentTypesToSelect={documentTypesToSelect}
                              roadTypesToSelect={roadTypesToSelect}
                              communityToSelect={communityToSelect} 
                              expanded={expanded}
                              optTypeToSelect={optTypeToSelect}
                            />
                          </div>
                        </AccordionDetails>
                    </Accordion>
                    { default_contract_view_aut_tras &&
                      <Accordion className="accordionOptTras-root" expanded={expanded === 'panel3'} onChange={handleChange('panel3')} >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel3bh-content"
                            id="panel3bh-header"
                            className="accordionOptTras-backcolor"
                          >
                            <Typography className="accordionOptTras-heading">{t('Text_CONTRACT_ORI_TRAS')} : <span>{t('Text_CONTRACT_ORI_TRAS_EMPR')}</span></Typography>
                            <Typography className="accordionOptTras-secondaryHeading">
                              {formContract.aut_tras_tradename!==undefined && formContract.aut_tras_tradename!==null && formContract.aut_tras_tradename!==""?formContract.aut_tras_tradename:t('Text_NOT_REPORTING')} 
                              {formContract.aut_tras_documentid!=="" && formContract.aut_tras_tradename===""?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_Tradename_Sheet_Required')} !!</span>:""}
                              {formContract.aut_tras_documentid!=="" && formContract.aut_tras_street!=="" && !formContract.aut_tras_postalcode_id?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_POSTALCODE_Aut_Tras_Required')} !!</span>:""}
                              {errorsForm.aut_tras_email!==undefined && errorsForm.aut_tras_email!==""?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Email_Sheet_Invalid')} !!</span>:""}
                              {(errorsForm.aut_tras_documentid!==undefined && errorsForm.aut_tras_documentid!=="") ||
                              (errorsForm.aut_tras_tradename!==undefined && errorsForm.aut_tras_tradename!=="") ||
                              (errorsForm.aut_tras_name!==undefined && errorsForm.aut_tras_name!=="") ||
                              (errorsForm.aut_tras_contactname!==undefined && errorsForm.aut_tras_contactname!=="") ||
                              (errorsForm.aut_tras_street!==undefined && errorsForm.aut_tras_street!=="") ||
                              (errorsForm.aut_tras_phone!==undefined && errorsForm.aut_tras_phone!=="") ||
                              (errorsForm.aut_tras_nima!==undefined && errorsForm.aut_tras_nima!=="") ||
                              (errorsForm.aut_tras_inscription!==undefined && errorsForm.aut_tras_inscription!=="") ||
                              (errorsForm.aut_tras_opt!==undefined && errorsForm.aut_tras_opt!=="")
                              ?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Character_Sheet_Invalid')} !!</span>:""}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <div className="accordion-inner-box">
                              <ContractCreateOrEditAutTras
                                formContract={formContract}
                                setFormContract={setFormContract}
                                setIsLoadingErrorData={setIsLoadingErrorData}
                                errorsForm={errorsForm}
                                setErrorsForm={setErrorsForm}
                                validateFormContract={validateFormContract}
                                documentTypesToSelect={documentTypesToSelect}
                                roadTypesToSelect={roadTypesToSelect}
                                communityToSelect={communityToSelect} 
                                expanded={expanded}
                                optTypeToSelect={optTypeToSelect}
                              />
                            </div>
                          </AccordionDetails>
                      </Accordion>
                    }
                    <Accordion className="accordionOptTras-root" expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel4bh-content"
                        id="panel4bh-header"
                        className="accordionOptTras-backcolor"
                      >
                        <Typography className="accordionOptTras-heading">{t('Text_CONTRACT_DEST_TRAS')} : <span>{t('Text_CONTRACT_DEST_TRAS_PROD')}</span></Typography>
                        <Typography className="accordionOptTras-secondaryHeading">
                          {formContract.dest_tras_tradename!==undefined && formContract.dest_tras_tradename!==null && formContract.dest_tras_tradename!==""?formContract.dest_tras_tradename:t('Text_NOT_REPORTING')}
                          {formContract.dest_tras_documentid!=="" && formContract.dest_tras_tradename===""?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_Tradename_Sheet_Required')} !!</span>:""}
                          {formContract.dest_tras_documentid!=="" && formContract.dest_tras_street!=="" && !formContract.dest_tras_postalcode_id?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_POSTALCODE_Dest_Tras_Required')} !!</span>:""}
                          {errorsForm.dest_tras_email!==undefined && errorsForm.dest_tras_email!==""?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Email_Sheet_Invalid')} !!</span>:""}
                          {(errorsForm.dest_tras_documentid!==undefined && errorsForm.dest_tras_documentid!=="") ||
                          (errorsForm.dest_tras_tradename!==undefined && errorsForm.dest_tras_tradename!=="") ||
                          (errorsForm.dest_tras_name!==undefined && errorsForm.dest_tras_name!=="") ||
                          (errorsForm.dest_tras_contactname!==undefined && errorsForm.dest_tras_contactname!=="") ||
                          (errorsForm.dest_tras_street!==undefined && errorsForm.dest_tras_street!=="") ||
                          (errorsForm.dest_tras_street_fiscal!==undefined && errorsForm.dest_tras_street_fiscal!=="") ||
                          (errorsForm.dest_tras_phone!==undefined && errorsForm.dest_tras_phone!=="") ||
                          (errorsForm.dest_tras_nima!==undefined && errorsForm.dest_tras_nima!=="") ||
                          (errorsForm.dest_tras_inscription!==undefined && errorsForm.dest_tras_inscription!=="") ||
                          (errorsForm.dest_tras_opt!==undefined && errorsForm.dest_tras_opt!=="")
                          ?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Character_Sheet_Invalid')} !!</span>:""}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div className="accordion-inner-box">
                          <ContractCreateOrEditDestTras
                            formContract={formContract}
                            setFormContract={setFormContract}
                            setIsLoadingErrorData={setIsLoadingErrorData}
                            errorsForm={errorsForm}
                            setErrorsForm={setErrorsForm}
                            validateFormContract={validateFormContract}
                            documentTypesToSelect={documentTypesToSelect}
                            roadTypesToSelect={roadTypesToSelect}
                            communityToSelect={communityToSelect} 
                            expanded={expanded} 
                            optTypeToSelect={optTypeToSelect}
                            />
                        </div>
                      </AccordionDetails>
                    </Accordion>
                    { default_contract_view_aut_dest &&
                      <Accordion className="accordionOptTras-root" expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel5bh-content"
                          id="panel5bh-header"
                          className="accordionOptTras-backcolor"
                        >
                          <Typography className="accordionOptTras-heading">{t('Text_CONTRACT_DEST_TRAS')} : <span>{t('Text_CONTRACT_DEST_TRAS_EMPR')}</span></Typography>
                          <Typography className="accordionOptTras-secondaryHeading">
                            {formContract.aut_dest_tradename!==undefined && formContract.aut_dest_tradename!==null && formContract.aut_dest_tradename!==""?formContract.aut_dest_tradename:t('Text_NOT_REPORTING')}
                            {formContract.aut_dest_documentid!=="" && formContract.aut_dest_tradename===""?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_Tradename_Sheet_Required')} !!</span>:""}
                            {formContract.aut_dest_documentid!=="" && formContract.aut_dest_street!=="" && !formContract.aut_dest_postalcode_id?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_POSTALCODE_Aut_Dest_Required')} !!</span>:""}
                            {errorsForm.aut_dest_email!==undefined && errorsForm.aut_dest_email!==""?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Email_Sheet_Invalid')} !!</span>:""}
                            {(errorsForm.aut_dest_documentid!==undefined && errorsForm.aut_dest_documentid!=="") ||
                            (errorsForm.aut_dest_tradename!==undefined && errorsForm.aut_dest_tradename!=="") ||
                            (errorsForm.aut_dest_name!==undefined && errorsForm.aut_dest_name!=="") ||
                            (errorsForm.aut_dest_contactname!==undefined && errorsForm.aut_dest_contactname!=="") ||
                            (errorsForm.aut_dest_street!==undefined && errorsForm.aut_dest_street!=="") ||
                            (errorsForm.aut_dest_phone!==undefined && errorsForm.aut_dest_phone!=="") ||
                            (errorsForm.aut_dest_nima!==undefined && errorsForm.aut_dest_nima!=="") ||
                            (errorsForm.aut_dest_inscription!==undefined && errorsForm.aut_dest_inscription!=="") ||
                            (errorsForm.aut_dest_opt!==undefined && errorsForm.aut_dest_opt!=="") ||
                            (errorsForm.aut_dest_economicactivity!==undefined && errorsForm.aut_dest_economicactivity!=="") ||
                            (errorsForm.aut_dest_licenseplate!==undefined && errorsForm.aut_dest_licenseplate!=="")
                            ?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Character_Sheet_Invalid')} !!</span>:""}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className="accordion-inner-box">
                            <ContractCreateOrEditAutDest
                              formContract={formContract}
                              setFormContract={setFormContract}
                              setIsLoadingErrorData={setIsLoadingErrorData}
                              errorsForm={errorsForm}
                              setErrorsForm={setErrorsForm}
                              validateFormContract={validateFormContract}
                              documentTypesToSelect={documentTypesToSelect}
                              roadTypesToSelect={roadTypesToSelect}
                              communityToSelect={communityToSelect} 
                              expanded={expanded}
                              optTypeToSelect={optTypeToSelect}
                              />
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    }
                    <div className="row p-2"> 
                      <div className="form-group">
                        <TableSortingCodeLERS 
                          dataCodeLERS={formContract.codelers} 
                          numTotRegCodeLERS={formContract.codelers.length}
                          setOpenDeleteRowCodeLERS={setOpenDeleteRowCodeLERS}
                          setOpenEditRowCodeLERS={setOpenEditRowCodeLERS}
                          setOpenCreateEditRowCodeLERS={setOpenCreateEditRowCodeLERS}
                          setEditRowCodeLER={setEditRowCodeLER} 
                          LIMITCODELERSCONTRACT={LIMITCODELERSCONTRACT}
                        />
                        <ContractCreateCodeLER 
                          openEditRowCodeLERS={openEditRowCodeLERS}
                          setOpenEditRowCodeLERS={setOpenEditRowCodeLERS} 
                          openCreateEditRowCodeLERS={openCreateEditRowCodeLERS} 
                          editRowCodeLER={editRowCodeLER}
                          formContract={formContract} 
                          setFormContract={setFormContract}
                        />
                      </div>
                    </div>
                    <Grid container spacing={4} justifyContent="space-around" alignItems="stretch">
                      {/* Firma Operador Traslado */}
                      <Grid item xs={4} sm={4} md={4} sx={{ margin: "auto" }} key={1}>
                        <div className="signature-card">
                          <div className="signature-box">
                            <SignatureCanvas
                              penColor="black"
                              ref={signDispatchedOptTrasCanvas}
                              canvasProps={{
                                width: CANVAS_SIZE,
                                height: CANVAS_SIZE,
                                style: {
                                  width: `${CANVAS_SIZE}px`,
                                  height: `${CANVAS_SIZE}px`,
                                  display: "block"
                                }
                              }}
                            />  
                          </div>
                          <div className="signature-title">{t("Text_Signature_Store_Prod")}</div>
                          <div className="sigblocksign-actions">
                            <Button className="sigblocksign-btn sigblocksign-btn-user"
                              onClick={() => handleSetSignatureOpt_tras()}
                              disabled={defaultsignature===""}>
                              {t("Button_Sign_User")}
                            </Button> 
                            <Button
                              className="sigblocksign-btn sigblocksign-btn-delete"
                              onClick={() => deleteSignature(1)}
                            >
                              {t("Button_Delete")}
                            </Button>
                          </div>  
                        </div>
                      </Grid>

                      {/* Firma Origen Traslado */}
                      <Grid item xs={4} sm={4} md={4} sx={{ margin: "auto" }} key={2}>
                        <div className="signature-card">
                          <div className="signature-box">
                            <SignatureCanvas
                              penColor="black"
                              ref={signDispatchedOriTrasCanvas}
                              canvasProps={{
                                width: CANVAS_SIZE,
                                height: CANVAS_SIZE,
                                style: {
                                  width: `${CANVAS_SIZE}px`,
                                  height: `${CANVAS_SIZE}px`,
                                  display: "block"
                                }
                              }}
                            />   
                          </div>
                          <div className="signature-title">{t("Text_Signature_Opt_Tras")}</div>
                          <div className="sigblocksign-actions">
                            <Button className="sigblocksign-btn sigblocksign-btn-user"
                              onClick={() => handleSetSignatureOri_tras()}
                              disabled={defaultsignature===""}>
                              {t("Button_Sign_User")}
                            </Button> 
                            <Button
                              className="sigblocksign-btn sigblocksign-btn-delete"
                              onClick={() => deleteSignature(2)}
                            >
                              {t("Button_Delete")}
                            </Button>
                          </div>   
                        </div>
                      </Grid>

                      {/* Firma Destino Destino */}
                      <Grid item xs={4} sm={4} md={4} sx={{ margin: "auto" }} key={3}>
                        <div className="signature-card">
                          <div className="signature-box">
                            <SignatureCanvas
                              penColor="black"
                              ref={signDispatchedDestTrasCanvas}
                              canvasProps={{
                                width: CANVAS_SIZE,
                                height: CANVAS_SIZE,
                                style: {
                                  width: `${CANVAS_SIZE}px`,
                                  height: `${CANVAS_SIZE}px`,
                                  display: "block"
                                }
                              }}
                            />  
                          </div>
                          <div className="signature-title">{t("Text_Signature_Store_Exploit")}</div>
                          <div className="sigblocksign-actions">
                            <Button className="sigblocksign-btn sigblocksign-btn-user"
                              onClick={() => handleSetSignatureDest_tras()}
                              disabled={defaultsignature===""}>
                              {t("Button_Sign_User")}
                            </Button> 
                            <Button
                              className="sigblocksign-btn sigblocksign-btn-delete"
                              onClick={() => deleteSignature(3)}
                            >
                              {t("Button_Delete")}
                            </Button>
                          </div>   
                        </div>
                      </Grid>  
                    </Grid>  
                  </div>
                </>:
                <LoadingNews/>
              }
            </form>
          </Box>
          <Dialog open={openDeleteRowCodeLERS} onClose={handleCancelDeleteRowCodeLER}>
              <DialogTitle style={{color:"#e74a3b"}}>{t('Text_Delete')}  {editRowCodeLER.codeler_code} - {i18n.language==='es'?editRowCodeLER.codeler_namees:editRowCodeLER.codeler_nameen} </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  {t('Text_Line1')}<br/>
                  {t('Text_Line2')}
                </DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  id="idCode"
                  label={t('Text_Label')}
                  type="text"
                  fullWidth
                  variant="standard"
                  error
                  defaultValue={idCodeDeleteCodeLER}
                  onChange={handleChangeDeleteRowCodeLER}/>
              </DialogContent>
              <DialogActions>
                <Button style={{color:"#e74a3b",fontSize: 16 }} onClick={handleCancelDeleteRowCodeLER}>{t('Button_Cancel')}</Button>
                <Button variant="contained" style={{color:"#ffffff", background:"#e74a3b",fontSize: 16}} onClick={handleCloseDeleteRowCodeLER}>{t('Button_Delete')}</Button>
              </DialogActions>
            </Dialog>
        </div>
      //* End Page Content *//
    ) :  null }
  </>
  )    
}

ContractEditOrCreate.propTypes = {
  id: PropTypes.string.isRequired,
  showModalContractSettings: PropTypes.bool.isRequired
};

export default ContractEditOrCreate;